import { CtaLink, Paragraph, PromotionCard } from '@purpurds/purpur';
import './TopPromotionCard.scss';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { CtaContent } from 'utils/models';
import { Dimensions, createMultipleSizeImages } from 'utils/utils';

type Props = {
  title?: string;
  preamble?: ReactNode;
  cta: CtaContent;
  image?: {
    url: string;
    altText: string;
    focusArea?: string;
  };
};

const TopPromotionCard = ({ title, preamble, cta, image }: Props) => {
  const { t } = useTranslation();

  const contentCard: Dimensions = {
    small: ['3:2', 550],
    medium: ['3:2', 850],
    large: ['3:4', 1440],
  };

  const imageSizes = createMultipleSizeImages(
    {
      url: image!.url,
      altText: image!.altText,
      focusArea: image!.focusArea,
    },
    contentCard
  );

  return (
    <div className="top-promotion-card">
      <PromotionCard
        variant="primary"
        title={title ? title : ''}
        key={title}
        hasGradient
        decorativeImage={
          <div className="top-promotion-card__image-wrapper">
            <picture>
              <source
                media="(max-width: 450px)"
                srcSet={image?.url ? imageSizes.small : '/image/purple-900.png'}
              />
              <source
                media="(max-width: 1050px)"
                srcSet={image?.url ? imageSizes.medium : '/image/purple-900.png'}
              />

              <img
                src={image?.url ? imageSizes.large : '/image/purple-900.png'}
                alt={imageSizes.altText}
                className="top-promotion-card__image"
              />
            </picture>
          </div>
        }
      >
        <div className="top-promotion-card__content">
          <Paragraph className="top-promotion-card__preamble">{preamble}</Paragraph>
          <div>
            <CtaLink variant="primary" negative href={cta.url}>
              {cta.text ? cta.text : t('read_more')}
            </CtaLink>
          </div>
        </div>
      </PromotionCard>
    </div>
  );
};

export default TopPromotionCard;
